<template>
    <div class="content">
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 v-show="false" class="h2 text-white d-inline-block mb-0">Operações</h6>
          <nav v-show="false" aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4"></nav>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <div>
        <b-card no-body>
          <b-card-body>
            <b-card-title class="h3 mb-0">Período e filtros</b-card-title>
            <div class="mt-3">
              <b-row>
                <b-col cols="12">
                  <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
                    <form class="needs-validation" @submit.prevent="handleSubmit(fetchItineraries)">
                      <b-row class="form-group">
                        <b-col md="4">
                          <base-input type="date" v-model="formDate.startDate" value="" id="example-date-input"/>
                        </b-col>
                        <b-col md="4">
                          <base-input type="date" v-model="formDate.endDate" value="" id="example-date-input"/>
                        </b-col>

                        <b-row class="pl-3">
                          <b-col>
                            <base-button @click="showFilterSearch = !showFilterSearch" icon type="primary">
                              <span class="btn-inner--icon">
                                <i :class="showFilterSearch ? 'ni ni-bold-up' : 'ni ni-bold-down'"></i>
                              </span>
                            </base-button>
                          </b-col>
                          <b-col>
                            <button type="submit" class="btn btn-primary">Buscar</button>
                          </b-col>
                        </b-row>
                      </b-row>
                    </form>
                  </validation-observer>
                  
                  <search-filter-operacao
                    ref="searchFilter"
                    :inputCategories="inputCategories"
                    :visible="showFilterSearch"
                    @categoriesSelected="setInputCategories"
                  />
                </b-col>
              </b-row>
            </div>
          </b-card-body>
        </b-card>
      </div>

      <div>
        <b-card no-body style="min-height:200px" ref="day_by_day_wrapper">
          <b-card-body>
            <calendar-operacao :events="filteredOperations" />
          </b-card-body>
        </b-card>
      </div>


    </b-container>
  </div>
</template>

<script>
import bocapioNodeService from '../../services/nodejs/index';

import SearchFilterOperacao from './SearchFilterOperacao.vue';
import CalendarOperacao from './CalendarOperacao.vue';

export default {
    name: "Itinerary",

    components:{
        SearchFilterOperacao,
        CalendarOperacao,
    },

    computed:{
      filteredOperations(){
        if(this.selectedCategories.length > 0){
          var vm = this;
          var filter = this.calendarInfo.filter(function(val,idx){
            var cats = JSON.parse(val.product_xfields)
            if('Subcategoria' in cats && vm.selectedCategories.includes(cats.Subcategoria.label)){ return val; }
          })
          return filter
        }
        else{ return this.calendarInfo; }
      }
    },

    data() {
        return {
          formDate: { startDate: "2021-01-01", endDate: "2021-01-31" }, showFilterSearch:false,

          inputCategories:[], selectedCategories:[],
          
          calendarInfo:[],
        }
    },

    methods: {
        // Get the array of itinerary categories to the filter
        setFilterItineraryCategories(){
            let cakeUserdata = JSON.parse(localStorage.getItem("cakeuserdata"));
            let cakeUserParams = JSON.parse(cakeUserdata.user.params);
            
            this.inputCategories = cakeUserParams['ProductXFields']['Categoria']['options'];
            this.inputCategories = Object.values(this.inputCategories);
            this.inputCategories = this.inputCategories.filter(el => el != "");
        },

        setFilterDates(){
            //setting first day of current month as picker start date
            var firstDayOfMonth = new Date()
            firstDayOfMonth.setDate(1)
            this.formDate.startDate = firstDayOfMonth.toLocaleDateString('pt-BR').split('/').reverse().join('-')
            
            //setting today as picker end date
            var today = new Date()
            this.formDate.endDate = today.toLocaleDateString('pt-BR').split('/').reverse().join('-')
        },

        setInputCategories(cats){ this.selectedCategories = cats; },

        fetchItineraries(){
          var { startDate: formStartDate, endDate: formEndDate } = this.formDate;
          var sDate = new Date(formStartDate);
          var eDate = new Date(formEndDate);

          if (sDate.getTime() > eDate.getTime()) {
            alert("Erro! a Data final deve ser após a data inicial !");
            return
          }

          //API TO GET OPERATIONS
          bocapioNodeService.getOperations(this.formDate)
            .then(res=>{
              var response = res.data; var vm = this

              //FILTERING BY CATEGORIES IN THE FILTER
              if(this.selectedCategories.length > 0){
                response = response.filter(function(val,idx){
                  var cats = JSON.parse(val.product_xfields);

                  if('Subcategoria' in cats && vm.selectedCategories.includes(cats.Subcategoria.label)){ 
                    return val; 
                  }
                })
              }

              this.calendarInfo = response;
            })
        },

    },

    created() {
      this.setFilterDates();
    },

    mounted() {
      this.setFilterItineraryCategories(); this.fetchItineraries();
    },

}
</script>